const Matl=() => {
    return(
        <div>
        <h2>자재 관리</h2>
        </div>
    )
}

export default Matl;